import { render, staticRenderFns } from "./MediaTpl.vue?vue&type=template&id=495a475b"
import script from "./MediaTpl.vue?vue&type=script&lang=js"
export * from "./MediaTpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports